export enum USER_TYPE {
    BROKER = "BROKER",
    EMPLOYER = "EMPLOYER",
    EMPLOYEE= "EMPLOYEE"
  }
  